import React from 'react';
import {
  SimpleForm,
  required,
  BooleanInput,
  DateTimeInput,
  usePermissions,
} from 'react-admin';
import { Toolbar } from '../../../components';
import { getUser } from '../../../user';

const Form = (props) => {
  // Fail closed: rely on react-admin permissions, fall back to the stored
  // user while the async AUTH_GET_PERMISSIONS call hasn't resolved yet (same
  // repli pattern as Cleaner/detail/Form.js and
  // Vivier/components/WarningsCard.js).
  const { permissions } = usePermissions();
  const user = permissions || getUser();

  // Mirror the server-side check (postgRest.js: hasPermission(user,
  // 'scheduler', 'delete', 1)) instead of a hardcoded role test, same motif
  // as Cleaner/detail/Form.js. There is no Scheduler/Create.js today (this
  // Form is only used by Scheduler/Edit.js), so `isCreate` is always false
  // in practice — kept anyway for defense in depth, in case a Create screen
  // reuses this Form later.
  const isCreate = !props.record || !props.record.id;
  const isDeletable =
    !isCreate && !!(user?.permissions?.scheduler?.delete >= 1);

  return (
    <SimpleForm
      {...props}
      redirect="list"
      toolbar={<Toolbar isDeletable={isDeletable} />}
    >
      <DateTimeInput source="next_execution_date" validate={[required()]} />
      <BooleanInput source="active" />
    </SimpleForm>
  );
};

export default Form;
